const PAGE_SIZE_OPTIONS = [10, 50, 100];

const TablePagination = ({ total, page, pageSize, onPage, onPageSize }) => {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const from = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);

  const getPageNumbers = () => {
    const pages = new Set([1, totalPages]);

    for (
      let i = Math.max(1, page - 1);
      i <= Math.min(totalPages, page + 1);
      i++
    ) {
      pages.add(i);
    }

    return [...pages].sort((a, b) => a - b);
  };

  return (
    <div className="pagination-container">
      <div className="pagination-info">
        <span>{total === 0 ? "No results" : `${from}-${to} of ${total}`}</span>

        <div className="pagination-rows">
          <span>Rows:</span>

          <select
            value={pageSize}
            onChange={(e) => {
              onPageSize(Number(e.target.value));
              onPage(1);
            }}
            className="pagination-select"
          >
            {PAGE_SIZE_OPTIONS.map((s) => (
              <option key={s} value={s}>
                {s}
              </option>
            ))}
          </select>
        </div>
      </div>

      {totalPages > 1 && (
        <div className="pagination-nav">
          <button
            onClick={() => onPage(1)}
            disabled={page === 1}
            className="pagination-arrow"
          >
            «
          </button>

          <button
            onClick={() => onPage(page - 1)}
            disabled={page === 1}
            className="pagination-arrow"
          >
            ‹
          </button>

          {getPageNumbers().reduce((acc, p, i, arr) => {
            if (i > 0 && p - arr[i - 1] > 1) {
              acc.push(
                <span key={`gap-${p}`} className="pagination-ellipsis">
                  ...
                </span>
              );
            }

            acc.push(
              <button
                key={p}
                onClick={() => onPage(p)}
                className={`pagination-btn ${p === page ? "active" : ""}`}
              >
                {p}
              </button>
            );

            return acc;
          }, [])}

          <button
            onClick={() => onPage(page + 1)}
            disabled={page === totalPages}
            className="pagination-arrow"
          >
            ›
          </button>

          <button
            onClick={() => onPage(totalPages)}
            disabled={page === totalPages}
            className="pagination-arrow"
          >
            »
          </button>
        </div>
      )}
    </div>
  );
};

export default TablePagination;
